import Crud from '../views/Cid/Crud'
import Entity from '../views/Cid/Add'

let routes = {
    path: '/cids',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/cids/add',
            name: 'NewCid',
            component: Entity
        },
        {
            path: '/cids/edit/:id?',
            name: 'EditCid',
            component: Entity
        },
        {
            path: '/cids',
            name: 'list-cids',
            component: Crud,
            meta: {
                pageTitle: 'Lista de CIDs',
                breadcrumb: [
                    {
                        text: 'CIDs',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
